import { WidgetPropertiesProvider} from "@wms/design-container";
import {inject} from "@angular/core";
import { widgetsConfig, addSubGroups } from './widgets/config';
import {forEach} from "lodash-es";
import {layoutConfig} from "@wms/app/design-container/content/layout/config";
import {containersConfig} from "@wms/app/design-container/content/layout/containers/config";
import {deviceConfig} from "@wms/app/design-container/content/device/config";

export interface SWSAttributes {
  classTarget? : string,  
  // The name of the container in the markup where you expect the class to be appended 
  // during dynamic markup generation. Example <wm-button class="" name="container_1"></wm-button>
  // Providing classTarget as container_1 will enable you to append the class to the button. 

  tagElements? : string,  
  // The name of the tag in a piece of markup where all elements with the particular tag 
  // must have the class added for dynamic preview generation. Please take a look at form-controls 
  // for an example of the same. 

}

export interface StyleWorkspaceTemplates {
  usageTemplate? : string,  // Template which depicts the different ways a widget can be used
  platforms? : any;
  markupExceptions? : any,  // JSON which contains a list of special cases or markup exceptions for widgets.
  customTemplate? : string[], // A default template which will be used for dynamic preview generation on StyleWS
  attributeObject? : SWSAttributes, // A detailed object which enlists how the markup should be amended for dynamic preview generation.
}



export interface WidgetDetailedInfo {
  widgetType: string;
  template: string;
  platforms?: { [key: string]: { template: string } };
  isContainer?: boolean;
  isResizable?: boolean;
  isMovableInsideCanvas?: boolean;
  isLayoutBundled?: boolean;
  isDroppable?: boolean;
  isDeletable?: boolean;
  canBeCopied?: boolean;
  isTemplateBundled?: boolean;
  config?: any;
  isPageContainer?: any;
  scaffold?: any;
  parent?: string;
  rightActionPanel?: any;
  bottomActionPanel?: any;
  tokenFileName?: string; /* The name of the token file associated with this widget in foundation-css*/
  styleWorkspaceTemplates?: StyleWorkspaceTemplates
}


export class RegisterWidgetProps {
  private wpProvider: WidgetPropertiesProvider;

  constructor() {
    this.wpProvider = inject(WidgetPropertiesProvider);

  }

  register() {
    forEach(widgetsConfig, (v: WidgetDetailedInfo, k: string) => {
      this.wpProvider.register(k, v);

    });
    forEach(layoutConfig, (value: WidgetDetailedInfo, key: string) => {
      this.wpProvider.register(key, value);
    });
    forEach(containersConfig, (value: WidgetDetailedInfo, key: string) => {
      this.wpProvider.register(key, value);
    });
    forEach(deviceConfig, (value: WidgetDetailedInfo, key: string) => {
      this.wpProvider.register(key, value);
    });

    addSubGroups(this.wpProvider);
  }
}
